import React from 'react';
import { connect } from 'react-redux';

import PublicHeader from '../PublicHeader/PublicHeader';
import PublicFooter from '../PublicFooter/PublicFooter';
import LoginModal from '../../Modals/Auth/LoginModal';
import RegisterModal from '../../Modals/Auth/RegisterModal';

import { closeModal } from '../../../store/actions';

import './PublicLayout.scss';

const PublicLayout = props => {
    return <div className='public-layout'>
        {/* {props.noHeader ? null : <PublicHeader />} */}
        {props.children}
        {/* {props.noFooter ? null : <PublicFooter />} */}
		<LoginModal isOpen={props.modal === 'login'} onClose={props.closeModal}/>
		<RegisterModal isOpen={props.modal === 'register'} onClose={props.closeModal}/>
    </div>
}

const mapStateToProps = state => {
    return {
        ...state.Layout
    }
}

const mapDispatchToProps = {
    closeModal
}

export default connect(mapStateToProps,  mapDispatchToProps)(PublicLayout);